import type { Action, State } from '../types';
import { applyRules } from './applyRules';

export function getErrorsFromStep(state: State, step: number, dispatch: React.Dispatch<Action>) {
  const globalErrors: Record<string, string[]> = {};

  const currentStepFields = Object.keys(state).filter((key) => state[key]?.step === step);

  currentStepFields.forEach((fieldName) => {
    const fieldValue = state[fieldName].value;
    const fieldValidations = state[fieldName].validations;

    const errors: string[] = [];
    fieldValidations?.forEach((rule: string) => {
      const ruleNotValid = applyRules(rule, fieldValue, state[fieldName]);
      if (ruleNotValid) {
        errors.push(ruleNotValid);
      }
    });
    if (errors.length > 0) {
      dispatch({ type: `set_errors`, value: { fieldName, errors } });
      globalErrors[fieldName] = errors;
    } else {
      dispatch({ type: `set_errors`, value: { fieldName, errors: [] } });
    }
  });

  const stepErrors = currentStepFields.map((key) => globalErrors[key]).filter((a) => a);
  return stepErrors;
}
